var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.3,
    viewBox: "0 0 32 32.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Tables",
    transform: "translate(-253 -70.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-icon",
    width: 32,
    height: 32,
    transform: "translate(253 71)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-Table",
    d: "M42.633,14c0-2.452-7.043-3.734-14-3.734s-14,1.284-14,3.734V17.01c0,2.223,5.786,3.484,12.05,3.7V31.345c-4.107,1.085-7.056,5.417-7.056,10.474a.443.443,0,0,0,.439.447h3.02a.443.443,0,0,0,.439-.447c0-2.75,1.271-5.217,3.156-6.259v6.259a.443.443,0,0,0,.439.447h3.02a.443.443,0,0,0,.439-.447l0-6.259c1.885,1.041,3.156,3.508,3.156,6.259a.443.443,0,0,0,.439.447H37.2a.443.443,0,0,0,.439-.447c0-5.057-2.949-9.389-7.056-10.474l0-10.633c6.264-.217,12.05-1.479,12.05-3.7ZM36.751,41.372H34.608c-.148-3.214-1.88-6.021-4.316-6.922a.432.432,0,0,0-.4.053.449.449,0,0,0-.187.366v6.5h-2.14v-6.5a.448.448,0,0,0-.187-.366.432.432,0,0,0-.4-.053c-2.434.9-4.167,3.709-4.314,6.922H20.517c.169-4.568,2.913-8.406,6.654-9.237H30.1c3.74.831,6.485,4.669,6.654,9.237ZM27.563,31.241V20.735c.356.006.713.011,1.07.011s.714,0,1.07-.011V31.241Zm14.19-14.23c0,1.186-4.991,2.841-13.12,2.841s-13.12-1.655-13.12-2.841V15.4c2.1,1.54,7.634,2.337,13.12,2.337s11.024-.8,13.12-2.339Zm-13.12-.17c-8.129,0-13.12-1.655-13.12-2.841s4.991-2.841,13.12-2.841S41.753,12.814,41.753,14,36.762,16.841,28.633,16.841Z",
    transform: "translate(239.867 60.734)",
    stroke: "#151515",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.7d7431bda2416f707a4a47093759ff90.svg";
export { ForwardRef as ReactComponent };